import React, { useEffect } from 'react';
import NxtbnModal from "../../components/Modal";
import { useQuery, gql, useLazyQuery } from "@apollo/client";
import { generateBulkInvoice, GET_INVOICES } from "../../pdf/generateBulkInvoice";

const GET_INVOICE_SETTINGS = gql`
  query MyQuery($first: Int, $last: Int) {
    invoiceSettings(first: $first, last: $last) {
      edges {
        node {
            storeName,
            city,
            contactEmail,
            dbId,
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

interface InvoiceChooserProps {
  isOpen: boolean;
  onClose: () => void;
  selectedItems?: any[];
}

function InvoiceChooser({ isOpen, onClose, selectedItems }: InvoiceChooserProps) {
  const [selectedInvoice, setSelectedInvoice] = React.useState<string | null>(null);



  const { data: invoiceSettingsData, loading: invoiceSettingsLoading, error: invoiceSettingsError, refetch: invoiceSettingRefetch } = useQuery(GET_INVOICE_SETTINGS, {
    variables: { first: 10 },
    notifyOnNetworkStatusChange: true,
});

const [fetchInvoices, { data, loading, error, refetch }] = useLazyQuery(GET_INVOICES);

useEffect(() => {
  if (data) {
    generateBulkInvoice(data);
    onClose();
  }
}, [data]);


  const handleSubmit = (id:any) => {
    fetchInvoices({ variables: { orderIds: selectedItems, invoiceSettingsId: id } })
  };

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      
      <div  className="p-6">
      <h3>Choose Invoice Template</h3>
        <div className="grid grid-cols-1 gap-4 mb-6 mt-4">
          {invoiceSettingsData?.invoiceSettings?.edges?.map((invoice:any) => (
            <div 
              key={invoice.node.dbId}
              onClick={() => handleSubmit(invoice.node.dbId)}
              className={`
                cursor-pointer rounded-lg p-4 transition-all border border-gray-200 hover:border-blue-300 hover:bg-gray-50`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="font-medium text-lg text-gray-900">
                    {invoice.node.storeName}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    {invoice.node.city} - {invoice.node.contactEmail}
                  </p>
                </div>                
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
      
    </NxtbnModal>
  );
}

export default InvoiceChooser;